import {html, css, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import global_css from './global-css';
import {ri, RunnerIdle} from './runner-idle';
import {Modal} from './modal';

export default function () {
  ri.gameSpeed = 0;
  const tutorial = document.querySelector('ri-tutorial') as Tutorial;
  if (tutorial) {
    const modal = tutorial.shadowRoot?.querySelector('ri-modal') as Modal;
    if (modal) {
      modal.open();
    }
  }
}

@customElement('ri-tutorial')
export class Tutorial extends LitElement {
  @property({type: Number}) stage = 0;

  static override styles = [global_css, css``];

  next() {
    this.stage += 1;
  }

  currentStageContent(stage: number) {
    let runnerIdle: RunnerIdle;
    switch (stage) {
      case 0:
        return html`
          <p>
            <!-- You awake to find yourself in a dark room.
            <br />
            Suddenly, a portal opens up! With nothing else going on, you walk
            through it. Upon exiting the portal, you find yourself at the start
            of a path winding down through the endless blue sky.
            <br />
            After walking for a while, the path starts to crumble beneath you,
            and you slip through the cracks. After falling for what feels like
            forever, the ground looms large before you. A booming voice calls
            out <span style="font-variant: small-caps;">"NOT SO FAST"</span>.

            <strong>BAM!</strong> -->

            Upon exiting the portal, you find yourself at the start of a path
            winding down through the endless blue sky! With a foreboding sense
            of déjà vu, you start to walk.
          </p>
          <p>Click the "Next" button to continue.</p>
          <button @click="${this.next}">Next</button>
        `;
      case 1:
        return html`
          <h1></h1>
          <p>
            This is a tutorial to help you get started. If you're familiar with
            other games in this subgenre, like Groundhog Life, Idle Loops,
            Immortality Idle, or Cavernous II, you can probably skip this
            tutorial, and if you aren't you should go play them after this!
          </p>
          <p>There's not much of a tutorial here yet, sorry!</p>
          <p>Click the "Next" button to continue.</p>
          <button @click="${this.next}">Next</button>
        `;
      default:
        (this.shadowRoot?.querySelector('ri-modal') as Modal)?.close();
        // Unpause
        runnerIdle = document.querySelector('runner-idle') as RunnerIdle;
        if (runnerIdle) {
          runnerIdle.gameSpeed = 1;
        }
        break;
    }
  }
  protected override render() {
    return html`
      <ri-modal .closeOnOverlay=${false}>
        ${this.currentStageContent(this.stage)}
      </ri-modal>
    `;
  }
}
